import localDeposit from '@/mixins/localDeposit.js'
import getBalance from '@/mixins/getBalance.js'
import provider from '@/mixins/provider.js'
import { COUNTRY_SHORTNAMES, COUNTRY_CODE_OPTIONS } from '@/utils/constants.js'
export default {
  mixins: [localDeposit, getBalance, provider],
  data () {
    return {
      ghanaianAccountNumberMinLength: 7,
      ghanaianAccountNumberMaxLength: 20,
      nigerianAccountNumber: 10,
      mobileMoneyAccountLengthMin: 9,
      mobileMoneyAccountLengthMax: 10,
      isAccountNameError: '',
      bankOptions: [],
      isSearchableBankName: false
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    getTransferDetail (currency, type) {
      const isAsset = type === 'asset'
      const transferDetails = this.$store.state.auth.transferDetails
      const details = transferDetails.find((detail) =>
        this.isSourceCurrency
          ? detail.from === currency && detail.to === this.secondaryCurrency
          : detail.from === this.activeCurrency && detail.to === currency
      )
      const walletDetails = this.walletAddresses.find(
        (wallet) => wallet.asset === currency && wallet.reason === 'transfer'
      )
      const sameCurrency = this.isSourceCurrency
        ? currency === this.secondaryCurrency
        : currency === this.activeCurrency
      if (isAsset && this.isSourceCurrency && !walletDetails) {
        return `Yet to register ${currency} for asset deposit`
      }
      if (!sameCurrency) {
        if (!details) {
          return `Can't transfer from  ${
            this.isSourceCurrency ? currency : this.activeCurrency
          } to ${this.isSourceCurrency ? this.secondaryCurrency : currency}`
        }
        if (!details.is_enabled && !this.isSourceCurrency) {
          return `Can't currently transfer from ${this.activeCurrency} to ${this.secondaryCurrency}`
        }
      }
    },
    isTransferable (currency, type) {
      const isAsset = type === 'asset'
      const transferDetails = this.$store.state.auth.transferDetails
      const sameCurrency = this.isSourceCurrency
        ? currency === this.secondaryCurrency
        : currency === this.activeCurrency
      const details = transferDetails.find((detail) =>
        this.isSourceCurrency
          ? detail.from === currency && detail.to === this.secondaryCurrency
          : detail.from === this.activeCurrency && detail.to === currency
      )
      const walletDetails = this.walletAddresses.find(
        (wallet) => wallet.asset === currency && wallet.reason === 'transfer'
      )
      if (isAsset && this.isSourceCurrency && !walletDetails) {
        return false
      }
      if (sameCurrency) {
        return true
      }
      return this.isSourceCurrency || details?.is_enabled
    },
    getNextAvailableCurrencyOption (currency) {
      const transferDetails = this.$store?.state?.auth?.transferDetails
      const details = transferDetails?.find(
        (detail) =>
          (this.isSourceCurrency ? detail.from : detail.to) === currency &&
          detail.is_enabled
      )
      this.$store.dispatch(
        'common/setSecondaryCurrency',
        this.isSourceCurrency ? details?.to : details?.from
      )
      this.$store.dispatch(
        'common/setActiveCurrency',
        this.isSourceCurrency ? details?.from : details?.to
      )
    },
    setCurrency (currency, type) {
      let details
      const transferDetails = this.$store?.state?.auth?.transferDetails
      const sameCurrency = this.isSourceCurrency
        ? currency === this.secondaryCurrency
        : currency === this.activeCurrency
      const getDetails = () => {
        if (transferDetails) {
          details = transferDetails.find((detail) =>
            this.isSourceCurrency
              ? detail.from === currency && detail.to === this.secondaryCurrency
              : detail.from === this.activeCurrency && detail.to === currency
          )
          return details
        }
      }
      getDetails()
      // If details are not available, check if currencies are the same, then swap
      if (!details || details.is_enabled === false) {
        if (sameCurrency) {
          const activeCurrency = this.activeCurrency
          const secondaryCurrency = this.secondaryCurrency
          this.$store.dispatch(
            'common/setActiveCurrency',
            this.isSourceCurrency ? currency : secondaryCurrency
          )
          this.$store.dispatch(
            'common/setSecondaryCurrency',
            this.isSourceCurrency ? activeCurrency : currency
          )
          const exchangedDetails = transferDetails.find((detail) =>
            this.isSourceCurrency
              ? detail.from === currency && detail.to === this.secondaryCurrency
              : detail.from === this.activeCurrency && detail.to === currency
          )
          const walletDetails = this.walletAddresses.find(
            (wallet) =>
              wallet.asset === this.activeCurrency &&
              wallet.reason === 'transfer'
          )
          if (
            exchangedDetails?.is_enabled === false ||
            (!walletDetails && this.transferSourceIsAsset)
          ) {
            this.getNextAvailableCurrencyOption(currency)
          }
        } else {
          this.getNextAvailableCurrencyOption(currency)
        }
      } else if (details && details.from === details.to) {
        // If from and to currency are the same in the details object, return to initial state
        this.$store.dispatch('common/setActiveCurrency', this.activeCurrency)
        this.$store.dispatch(
          'common/setSecondaryCurrency',
          this.secondaryCurrency
        )
      } else {
        this.$store.dispatch(
          this.isSourceCurrency
            ? 'common/setActiveCurrency'
            : 'common/setSecondaryCurrency',
          currency
        )
      }
      this.$emit('clearInput')
      this.$emit('closeAccountSelection')
      this.handleClose()
    },
    async switchCurrency () {
      const vm = this
      if (this.transferable) {
        const activeCountry = this.country.name
        const secondaryCountry = this.country2.name
        this.$store.dispatch('common/setSecondaryCountry', activeCountry)
        this.$store.dispatch('common/setActiveCountry', secondaryCountry)
        if (this.inputAmountFieldIsNotEmpty) {
          // swap send amount to recipient amount
          const enteredAmountInput = this.enteredAmountForm.enteredAmount
          const recipientAmountInput = this.enteredAmountForm.recipientAmount
          if (this.firstInputSelected) {
            this.enteredAmountForm.enteredAmount = enteredAmountInput
            this.calcFirstInput()
          } else {
            this.enteredAmountForm.recipientAmount = recipientAmountInput
            this.calcSecondInput()
          }
        }
      } else {
        vm.$message({
          showClose: true,
          message: `Can't transfer from ${this.secondaryCurrency}  to ${this.activeCurrency} at the moment`,
          type: 'info'
        })
      }
    },
    calcFirstInput () {
      this.firstInputSelected = true
      this.calculate()
    },
    calcSecondInput () {
      this.firstInputSelected = false
      this.calculate()
    },
    handleInput (fieldName, calcFunction) {
      let pattern = /[^\d.]/g
      if (this.isHub2Provider) {
        pattern = /[^\d]/g
      }
      this.enteredAmountForm[fieldName] = this.enteredAmountForm[
        fieldName
      ].replace(pattern, '')

      calcFunction()
    },
    calculate () {
      if (this.firstInputSelected) {
        this.enteredAmountForm.recipientAmount = this.recipientAmount
      } else {
        this.enteredAmountForm.enteredAmount =
          this.switchRecipientAmount || this.enteredAmount
      }
    },
    initiateTerminalTransfer (details) {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('terminal/initiateTransfer', details)
        .then(() => {
          this.isLoading = false
          this.$store.dispatch(
            'transactions/setCurrentTransaction',
            this.$store.state.terminal.transferInfo.transfer || {}
          )
          this.$store.dispatch(
            'transactions/setTransactionDetails',
            this.$store.state.terminal.transferInfo.transfer || {}
          )
          if (this.isWireTransferMethod) {
            this.handleWireTransfer()
          } else if (this.isBankTransferMethod) {
            this.handleBankTransfer()
          } else if (this.isFromHoldingsMethod) {
            this.done()
          }
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$swal({
            icon: 'error',
            title: 'Oops',
            text: err,
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    initiateHoldingsTransfer (twoFaCode) {
      const payload = {
        ...this.currentTransferDetails,
        twoFaCode: twoFaCode.code,
        source: 'treasury',
        sourceCurrency: this.country.currency,
        amount: this.transferDetails.debitAmount
      }
      this.showVerifyAuthDialog = false
      this.initiateTerminalTransfer(payload)
    },
    validateRecipientInfoForm (recipientInfoForm) {
      this.isLoading = true
      this.$refs[recipientInfoForm].validate((valid) => {
        if (valid) {
          if (this.transferDestinationIsLocal) {
            this.recipientInfoForm.recipientName =
              this.recipientInfoForm.accountName
          }
          this.$store.dispatch(
            'terminal/setRecipientInformation',
            this.recipientInfoForm
          )
          this.$store.dispatch('terminal/usedBeneficiary', false)
          this.$store.dispatch('terminal/beneficiaryOption', true)
          this.isLoading = false
          this.$emit('next')
        } else {
          this.isLoading = false
          this.$notify.error({
            title: 'Incomplete details',
            message: 'Please fill the missing information',
            position: 'top-right'
          })
        }
      })
    },
    async prefillLocalDetails () {
      if (this.recipientInfo && Object.keys(this.recipientInfo).length > 0) {
        await delete this.recipientInfo.bankCountry
        this.recipientInfoForm = { ...this.recipientInfo }
        this.setLocalCountry()
      }
      this.determineFormRuleMessageForCommonFields()
    },
    determineFormRuleMessageForCommonFields () {
      // pick error message based on payout method
      this.rules.bankName[0].message = this.isMobileMoneyPayoutMethod
        ? 'Please select a money provider'
        : "Please input Bank's name"
      this.rules.accountNo[0].message = this.isMobileMoneyPayoutMethod
        ? 'Please enter phone number'
        : 'Please input account no'
    },
    async validateAccountNo (rule, value, callback) {
      if (this.isLoading) return // Prevent multiple calls of this endpoint simultaneously
      if (!this.isFallBackAccountName) {
        callback() // No need to validate if not falling back to manual entry
        return
      }

      if (!this.computeValidAccountNumberLength(value.length)) {
        const errorMessage = this.getAccountNumberLengthErrorMessage()
        callback(new Error(errorMessage))
        return
      }

      if (!this.recipientInfoForm.bankName) {
        callback() // No need to validate if bank name is not provided
        return
      }

      // Only call the endpoint if there is no account name to prevent validation every time
      if (this.isAccountNameError !== 'false') {
        try {
          if (this.isMobileMoneyPayoutMethod) {
            await this.resolveMoneyProviderAccountName(value)
          } else {
            await this.resolveAccountName(value)
          }

          if (this.isAccountNameError === 'true') {
            callback(new Error('Please enter correct account details'))
          } else {
            callback()
          }
        } catch (error) {
          callback(new Error('Error occurred while validating account details'))
        }
      } else {
        callback()
      }
    },
    remoteMethodBanks (query, country) {
      if (query.trim() !== '') {
        switch (country) {
          case this.$COUNTRY.NG:
          case this.$COUNTRY.GH:
          case this.$COUNTRY.CI:
          case this.$COUNTRY.CM:
            this.getSupportedBanks().then(() => {
              this.bankOptions = this.supportedBanks.filter((item) => {
                return item.name.toLowerCase().includes(query.toLowerCase())
              })
            })
            break
          default:
            this.bankOptions = []
            break
        }
      } else {
        this.bankOptions = []
      }
    },
    getErrorMessage (errorMessage) {
      if (this.supportedBanksProviderIsZeepay) {
        return {
          title: 'Cannot fetch account name',
          message: 'Kindly input this manually',
          position: 'top-right'
        }
      } else {
        return {
          title: this.httpErrorMessage.customMessage,
          message: errorMessage,
          position: 'top-right'
        }
      }
    },
    prefillRecipientFormInfo () {
      if (this.recipientInfo && Object.keys(this.recipientInfo).length > 0) {
        this.recipientInfoForm = this.recipientInfo
      }
    },
    async resolveAccountNameCore (number) {
      this.isLoading = true
      // resolve account name core endpoint call
      this.recipientInfoForm.accountName = '...'
      await this.$store
        .dispatch('terminal/setResolveAccountName', {
          account_number: number,
          bank_code:
            // this.recipientInfoForm.providerCode ||
            this.recipientInfoForm.bankCode,
          currency: this.country2.currency
        })
        .then(() => {
          this.isLoading = false
          this.isAccountNameError = 'false'
          this.recipientInfoForm.accountName =
            this.$store.state.terminal.resolveAccountName
          // here, since nsano returns empty string as account name on dev,
          // we would allow manual account name input
          if (this.isOnDevEnvironment && !this.secondaryCurrencyIsNGN) {
            this.isAccountNameError = 'fallback'
          }
        })
        .catch((error) => {
          this.isLoading = false
          this.recipientInfoForm.accountName = ''
          const err = error.response
            ? error?.response?.data?.error?.publicMessage
            : error
          if (err) {
            const errorNotification = this.getErrorMessage(err)
            this.$notify.error(errorNotification)
          } else {
            // this.recipientInfoForm.accountName = this.recipientInfo.recipientName // to be updated
          }
          this.isAccountNameError = 'fallback'
        })
    },
    async validateMobilePhoneNumber () {
      const payload = {
        phoneNumber: this.recipientInfoForm.accountNo,
        countryCode: this.recipientInfoForm.bankAccountCountry
      }
      this.loading = true
      await this.$store
        .dispatch('terminal/setValidatePhoneNumber', payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getSupportedBanks () {
      const payload = {
        currency: this.country2.currency,
        payoutType: this.isMobileMoneyPayoutMethod ? 'mno' : ''
      }
      this.loading = true
      await this.$store
        .dispatch('terminal/getSupportedBanks', payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getSupportedCountries () {
      this.loading = true
      await this.$store
        .dispatch('terminal/getSupportedCountries')
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setLocalCountry () {
      const currencyToCountryMap = {
        [this.$CURRENCY.NGN]: { bankCountry: 'NG', countryCode: 'NG' },
        [this.$CURRENCY.GHS]: { bankCountry: 'GH', countryCode: 'GH' },
        [this.$CURRENCY.XOF]: { bankCountry: 'CI', countryCode: 'CI' },
        [this.$CURRENCY.XAF]: { bankCountry: 'CM', countryCode: 'CM' }
      }

      const currency = this.country2.currency
      if (currency in currencyToCountryMap) {
        const { bankCountry, countryCode } = currencyToCountryMap[currency]
        if (this.recipientInfoForm) {
          this.recipientInfoForm.bankCountry = bankCountry
          this.recipientInfoForm.countryCode = countryCode
          this.recipientInfoForm.recipientCountry = this.country2.name
        }
      } else {
        if (this.recipientInfoForm) {
          this.recipientInfoForm.bankCountry = currency
        }
      }
    },
    async getBeneficiaries (page = 1, destination, size = 1000) {
      const transfer_destination =
        destination === 'local_transfer' ? '' : destination
      const payload = {
        page,
        transfer_destination,
        size
      }
      try {
        await this.$store.dispatch('terminal/getBeneficiaries', payload)
      } catch (error) {
        this.handleErrorResponseNotification(error)
      }
    },
    getAccountNumberLengthErrorMessage () {
      if (this.isMobileMoneyPayoutMethod) {
        return '9 - 10 digits required'
      } else if (this.isGhanianDetails) {
        return '7 - 20 digits required'
      } else {
        return '10 digits required'
      }
    },
    computeValidAccountNumberLength (accountNumberLength) {
      // Check if it's a mobile money payout method
      if (this.isMobileMoneyPayoutMethod) {
        return (
          accountNumberLength >= this.mobileMoneyAccountLengthMin &&
          accountNumberLength <= this.mobileMoneyAccountLengthMax
        )
      }
      // Check if it's for Ghanaian details
      if (this.isGhanianDetails) {
        const parsedLength = parseInt(accountNumberLength)
        return (
          parsedLength >= this.ghanaianAccountNumberMinLength &&
          parsedLength <= this.ghanaianAccountNumberMaxLength
        )
      }
      // For other cases (Nigerian details)
      return parseInt(accountNumberLength) === this.nigerianAccountNumber
    }
  },
  computed: {
    isGhanianDetails () {
      return this.recipientInfoForm.bankCountry === COUNTRY_SHORTNAMES.GH
    },
    formattedBankOptions () {
      // remove duplicates
      const seen = new Set()
      return this.bankOptions.filter((item) => {
        const key = item.name + item.code
        return seen.has(key) ? false : seen.add(key)
      })
    },
    currentMoneyProvider () {
      let data = []
      if (this.secondaryCurrencyIsGHS) {
        data = this.ghsMoneyProviders
      } else {
        data = this.francMoneyProviders
      }
      return data
    },
    currentCountryCode () {
      const combinedArray = this.bankOptions
        .map((item) => {
          const matchingCountry = COUNTRY_CODE_OPTIONS.find(
            (option) => option.value === item.country
          )
          return matchingCountry
            ? { ...matchingCountry, providerName: item.name }
            : null
        })
        .filter(Boolean)

      return this.recipientInfoForm.bankName
        ? combinedArray.filter(
            (item) => item.providerName === this.recipientInfoForm.bankName
          )
        : []
    },
    supportedBanks () {
      return Object.values(this.$store.state.terminal.supportedBanks)[0]
    },
    supportedBanksProvider () {
      return Object.keys(this.$store.state.terminal.supportedBanks)[0]
    },
    isFallBackAccountName () {
      return (
        this.isSearchableBankDetails &&
        this.isAccountNameError !== 'fallback' &&
        !this.secondaryCurrencyIsXAF &&
        !this.secondaryCurrencyIsXOF
      )
    },
    isSearchableBankDetails () {
      return (
        (this.recipientInfoForm.bankCountry === 'NG' ||
          this.recipientInfoForm.bankCountry === 'GH') &&
        this.transferDestinationIsLocal
      )
    },
    ghanaCountryCode () {
      return this.countryCodeOptions.filter((code) => code.value === 'GH')
    },
    cameroonCountryCode () {
      return this.countryCodeOptions.filter((code) => code.value === 'CM')
    },
    civCountryCode () {
      return this.countryCodeOptions.filter(
        (code) => code.value === 'CI' || code.value === 'SN'
      )
    },
    isFrancDestinationCurrency () {
      return this.secondaryCurrencyIsXAF || this.secondaryCurrencyIsXOF
    },
    currentTransferDetails () {
      return this.$store.state.terminal.currentTransferDetails
    },
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    selectedDepositMethod () {
      return this.$store.state.terminal.depositMethod
    },
    isNewDepositMethod () {
      return this.selectedDepositMethod === 'new deposit'
    },
    isFromHoldingsMethod () {
      return this.depositMethod === 'holdings' || this.fromHoldingsBalance
    },
    depositMethod () {
      return this.$store.state.terminal.initiateTransferMethod
    },
    fromHoldingsBalance () {
      const account = this.filteredDepositAccounts.find(
        (item) => item.currency === this.selectedDepositMethod
      )
      return account ? !!account.currency : false
      // return !this.isNewDepositMethod
    },
    selectedHoldingsAccount () {
      // First check finds the holdings account of the selected holdings deposit currency, 2nd check finds the holdings account of the selected FROM currency account if available
      let details = {}
      if (this.fromHoldingsBalance) {
        details = this.filteredDepositAccounts.find(
          (item) => item.currency === this.selectedDepositMethod
        )
      } else {
        details = this.filteredDepositAccounts.find(
          (item) => item.currency === this.country.currency
        )
      }
      return details?.currency ? details : {}
    },
    selectedHoldingsAccountBalance () {
      return this.selectedHoldingsAccount.currentBalance
    },
    inputAmountFieldIsNotEmpty () {
      return (
        this.enteredAmountForm.enteredAmount &&
        this.enteredAmountForm.recipientAmount &&
        this.enteredAmountForm.enteredAmount !== ''
      )
    },
    recipientInfo () {
      return (
        this.$store.state.terminal.transferTerminalDetails
          .recipientInformation || {}
      )
    },
    walletAddresses () {
      return this.$store.state.transactions.walletAddresses.items || []
    }
  },
  watch: {
    async 'recipientInfoForm.accountNo' (newValue) {
      // this.isAccountNameError = 'false'
      if (this.isFallBackAccountName) {
        if (this.computeValidAccountNumberLength(newValue.length)) {
          this.recipientInfoForm.accountName = ''
        }
      }
    },
    '$store.state.common.secondaryCountry': {
      handler (value) {
        if (this.transferDestinationIsLocal) {
          this.setLocalCountry()
        }
      },
      immediate: true
    },
    // use beneficiary
    recipientInfo (newValue) {
      this.recipientInfoForm = newValue
    }
  }
}
